import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const ICON_HORN = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
        <g clipPath="url(#clip0_84_552)">
            <path
                d="M1.7838 19.3374C1.7838 19.3374 0.158598 19.8215 0.0155268 20.2889C-0.13984 20.7964 0.905253 24.3167 1.61055 24.3758C2.31585 24.4338 3.38777 23.7724 3.38777 23.7724L1.7838 19.3374Z"
                fill="#407BFF"
            />
            <path
                d="M6.76343 25.103C6.76343 25.103 8.88826 34.4023 9.07828 35.0036C9.26718 35.6048 14.2859 35.2668 14.192 34.8162C14.097 34.3655 12.9133 33.6137 12.9613 33.0136C13.0094 32.4135 13.5291 31.4364 13.4353 30.9479C13.3402 30.4593 11.9677 30.0087 12.1096 29.2201C12.2516 28.4314 12.968 27.838 13.0161 27.2747C13.063 26.7114 12.6305 25.0483 12.6305 25.0483L6.76455 25.1041L6.76343 25.103Z"
                fill="#407BFF"
            />
            <path
                opacity="0.3"
                d="M6.76343 25.103C6.76343 25.103 8.88826 34.4023 9.07828 35.0036C9.26718 35.6048 14.2859 35.2668 14.192 34.8162C14.097 34.3655 12.9133 33.6137 12.9613 33.0136C13.0094 32.4135 13.5291 31.4364 13.4353 30.9479C13.3402 30.4593 11.9677 30.0087 12.1096 29.2201C12.2516 28.4314 12.968 27.838 13.0161 27.2747C13.063 26.7114 12.6305 25.0483 12.6305 25.0483L6.76455 25.1041L6.76343 25.103Z"
                fill="black"
            />
            <path
                d="M2.79878 23.5213C2.79878 23.5213 -0.719886 17.7255 5.34501 15.3496L8.31039 25.0873C8.31039 25.0873 4.20602 25.9239 2.79878 23.5213Z"
                fill="#407BFF"
            />
            <path
                d="M5.55735 15.2201C5.55735 15.2201 10.5358 12.2831 12.3678 11.1197C15.7892 8.948 17.771 6.3457 17.771 6.3457L24.6943 25.8925C24.6943 25.8925 18.1085 25.3872 14.563 25.1619C11.0175 24.9377 7.8655 25.1061 7.8655 25.1061C7.8655 25.1061 5.33268 22.747 4.99512 18.9835C4.65756 15.2201 5.55847 15.2201 5.55847 15.2201H5.55735Z"
                fill="#407BFF"
            />
            <path
                opacity="0.7"
                d="M5.55735 15.2201C5.55735 15.2201 10.5358 12.2831 12.3678 11.1197C15.7892 8.948 17.771 6.3457 17.771 6.3457L24.6943 25.8925C24.6943 25.8925 18.1085 25.3872 14.563 25.1619C11.0175 24.9377 7.8655 25.1061 7.8655 25.1061C7.8655 25.1061 5.33268 22.747 4.99512 18.9835C4.65756 15.2201 5.55847 15.2201 5.55847 15.2201H5.55735Z"
                fill="white"
            />
            <path
                d="M29.1138 27.3564C33.7845 26.2563 36.167 19.4289 34.4353 12.1071C32.7036 4.78523 27.5134 -0.258498 22.8427 0.841597C18.1721 1.94169 15.7896 8.76903 17.5213 16.0909C19.253 23.4127 24.4431 28.4565 29.1138 27.3564Z"
                fill="#407BFF"
            />
            <path
                opacity="0.3"
                d="M29.003 25.1076C32.4925 24.2857 34.1571 18.6973 32.7211 12.6255C31.2851 6.55373 27.2921 2.29786 23.8026 3.11975C20.3132 3.94164 18.6485 9.53005 20.0846 15.6018C21.5206 21.6736 25.5135 25.9295 29.003 25.1076Z"
                fill="black"
            />
            <g opacity="0.3">
                <path
                    d="M20.1832 7.22013C21.3356 6.91004 23.1698 8.22959 24.2887 9.50453C27.7772 13.4822 28.241 19.8334 25.4254 24.3108C20.9611 21.501 18.321 13.1263 20.1832 7.22013Z"
                    fill="black"
                />
            </g>
            <path
                d="M5.32373 25.1052C5.32373 25.1052 7.07412 34.7359 7.22949 35.3583C7.38486 35.9807 11.5172 35.6304 11.4389 35.1642C11.3607 34.6979 10.386 33.9194 10.4251 33.297C10.4642 32.6745 10.8923 31.6628 10.8152 31.1576C10.737 30.6523 9.60694 30.1849 9.7243 29.3684C9.84166 28.5519 10.4318 27.9373 10.471 27.3539C10.5101 26.7706 10.1535 25.0483 10.1535 25.0483L5.32373 25.1063V25.1052Z"
                fill="#407BFF"
            />
            <path
                d="M20.0803 15.6014C20.4403 17.1228 20.96 18.5305 21.5927 19.772C21.9336 19.6192 28.1829 16.815 28.3684 16.6287C28.5596 16.438 26.8863 10.8062 26.8863 10.8062L19.5796 12.0052C19.6265 13.1597 19.7897 14.37 20.0803 15.6003V15.6014Z"
                fill="#407BFF"
            />
            <path
                opacity="0.7"
                d="M20.0803 15.6014C20.4403 17.1228 20.96 18.5305 21.5927 19.772C21.9336 19.6192 28.1829 16.815 28.3684 16.6287C28.5596 16.438 26.8863 10.8062 26.8863 10.8062L19.5796 12.0052C19.6265 13.1597 19.7897 14.37 20.0803 15.6003V15.6014Z"
                fill="white"
            />
            <path
                d="M28.3089 16.6045C29.2227 16.3892 29.6557 14.9131 29.2759 13.3075C28.8962 11.7019 27.8475 10.5747 26.9337 10.79C26.0199 11.0052 25.5869 12.4813 25.9666 14.0869C26.3464 15.6926 27.3951 16.8197 28.3089 16.6045Z"
                fill="#407BFF"
            />
            <g opacity="0.3">
                <path
                    d="M10.7426 27.8526C11.316 27.7879 11.8894 27.7232 12.4628 27.6596C12.5522 27.6495 12.6305 27.5904 12.6305 27.4923C12.6305 27.4097 12.5534 27.3149 12.4628 27.325C11.8894 27.3896 11.316 27.4543 10.7426 27.5179C10.6532 27.528 10.575 27.5871 10.575 27.6852C10.575 27.7678 10.6521 27.8626 10.7426 27.8526Z"
                    fill="black"
                />
            </g>
            <g opacity="0.3">
                <path
                    d="M11.0981 31.0271C11.7956 30.9569 12.4941 30.9033 13.195 30.8676C13.4096 30.8565 13.4107 30.5218 13.195 30.533C12.4953 30.5687 11.7956 30.6222 11.0981 30.6925C11.0075 30.7014 10.9304 30.7628 10.9304 30.8598C10.9304 30.9435 11.0075 31.036 11.0981 31.0271Z"
                    fill="black"
                />
            </g>
            <path
                d="M10.7426 25.0649C10.6632 25.0805 10.9784 27.018 11.3227 27.0381C11.667 27.0582 13.5694 26.9745 13.5794 26.8061C13.6018 26.4146 13.1268 25.0895 13.1268 25.0895C13.1268 25.0895 11.316 24.95 10.7426 25.0649Z"
                fill="#263238"
            />
            <g opacity="0.3">
                <path
                    d="M0.340989 21.5836C0.534359 21.5356 0.72773 21.4887 0.922217 21.4408C1.00717 21.4196 1.06641 21.3192 1.03958 21.2344C1.01275 21.1497 0.924453 21.095 0.832798 21.1173C0.639428 21.1653 0.446057 21.2121 0.251569 21.2601C0.166621 21.2813 0.10738 21.3817 0.134206 21.4664C0.161032 21.5512 0.249334 21.6059 0.340989 21.5836Z"
                    fill="black"
                />
            </g>
            <g opacity="0.3">
                <path
                    d="M0.513108 22.2442C0.706479 22.1962 0.899849 22.1494 1.09434 22.1014C1.17929 22.0802 1.23853 21.9798 1.2117 21.8951C1.18487 21.8103 1.09657 21.7556 1.00492 21.778C0.811547 21.8259 0.618177 21.8728 0.423689 21.9207C0.33874 21.9419 0.279499 22.0423 0.306325 22.1271C0.333151 22.2119 0.421453 22.2665 0.513108 22.2442Z"
                    fill="black"
                />
            </g>
            <g opacity="0.3">
                <path
                    d="M0.771165 22.9044C0.964535 22.8564 1.15791 22.8095 1.35239 22.7616C1.43734 22.7404 1.49658 22.64 1.46976 22.5552C1.44293 22.4705 1.35463 22.4158 1.26297 22.4381C1.0696 22.4861 0.876233 22.5329 0.681745 22.5809C0.596796 22.6021 0.537556 22.7025 0.564382 22.7872C0.591208 22.872 0.67951 22.9267 0.771165 22.9044Z"
                    fill="black"
                />
            </g>
            <g opacity="0.3">
                <path
                    d="M1.06194 23.606C1.25531 23.5581 1.44868 23.5112 1.64316 23.4632C1.72811 23.4421 1.78735 23.3417 1.76053 23.2569C1.7337 23.1721 1.6454 23.1175 1.55374 23.1398C1.36037 23.1877 1.167 23.2346 0.972517 23.2825C0.887568 23.3037 0.828327 23.4041 0.855153 23.4889C0.881979 23.5737 0.970281 23.6283 1.06194 23.606Z"
                    fill="black"
                />
            </g>
            <path
                opacity="0.3"
                d="M5.70167 15.7445C5.70167 15.7445 5.20539 18.9636 6.24266 20.2887C7.27993 21.6139 17.2972 17.4923 17.2972 17.4923C17.2972 17.4923 15.5535 13.2247 16.4577 9.96095C16.7383 8.94814 16.7886 8.57893 16.612 8.63247C16.2163 8.75294 14.7722 10.7284 11.6235 12.3982C9.48636 13.5314 5.70167 15.7456 5.70167 15.7456V15.7445Z"
                fill="white"
            />
            <path
                opacity="0.3"
                d="M5.32373 25.1027L5.50033 26.0776C5.50033 26.0776 13.2653 26.1278 13.3559 25.7842L13.1267 25.0893C11.8435 24.97 8.46125 25.0469 5.32373 25.1027Z"
                fill="black"
            />
            <path
                opacity="0.3"
                d="M23.4168 18.95C21.4429 15.9395 21.2238 12.6445 21.2026 11.7388L19.5796 12.0054C19.6265 13.1598 19.7897 14.3701 20.0803 15.6004C20.4403 17.1218 20.96 18.5295 21.5927 19.771C21.7044 19.7208 22.4544 19.3839 23.4168 18.9489V18.95Z"
                fill="black"
            />
            <path
                opacity="0.3"
                d="M1.78382 19.3371C2.09232 20.9611 2.51148 22.5071 3.09382 23.9349L2.80544 24.0754C2.65678 24.1412 1.17689 19.5311 1.38591 19.4687C1.45744 19.4475 1.78382 19.3359 1.78382 19.3359V19.3371Z"
                fill="black"
            />
            <path
                opacity="0.1"
                d="M24.9515 3.76153C24.7861 3.72695 23.2917 6.74084 23.4169 7.17475C23.542 7.60865 25.5003 10.0001 25.9787 10.0001C26.4571 10.0001 30.5928 9.81274 30.5928 9.2963C30.5928 8.77985 28.525 4.51221 24.9526 3.76153H24.9515Z"
                fill="white"
            />
            <path
                opacity="0.1"
                d="M28.6602 18.1383C28.6602 18.1383 27.4374 22.2453 27.6196 22.6C27.8018 22.9547 30.6442 22.6736 31.2869 22.0111C31.9307 21.3485 32.6271 18.0847 32.5734 17.5493C32.5198 17.0139 28.6591 18.1383 28.6591 18.1383H28.6602Z"
                fill="white"
            />
            <g opacity="0.2">
                <path
                    d="M10.4643 34.488C10.3537 34.1255 9.8641 34.0798 9.70091 33.7574C9.5053 33.3726 9.9144 32.9342 9.87751 32.5037C9.85404 32.2282 9.64278 31.9984 9.39688 31.8723C9.15098 31.7463 8.87042 31.7084 8.59657 31.6705C8.16177 31.6113 7.59619 31.5745 7.2251 31.8065C7.23292 32.4658 7.44306 33.2789 7.63755 33.9091C7.71914 34.1735 7.82533 34.4468 8.03882 34.623C8.2333 34.7847 8.4915 34.8439 8.74188 34.8818C9.17557 34.9465 9.61708 34.9576 10.0541 34.9152C10.2117 34.8996 10.3883 34.8673 10.4576 34.71C10.4889 34.6397 10.4867 34.5594 10.4643 34.4869V34.488Z"
                    fill="white"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_84_552">
                <rect width="35" height="35" fill="white" transform="translate(0 0.693848)" />
            </clipPath>
        </defs>
    </svg>
);

const ICON_STAR = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="153" height="26" viewBox="0 0 153 26" fill="none">
        <path
            d="M12.5 0.433105L15.3064 9.07039H24.3882L17.0409 14.4085L19.8473 23.0458L12.5 17.7077L5.15268 23.0458L7.95911 14.4085L0.611794 9.07039H9.69357L12.5 0.433105Z"
            fill="url(#paint0_linear_61_801)"
        />
        <path
            d="M44.5 0.433105L47.3064 9.07039H56.3882L49.0409 14.4085L51.8473 23.0458L44.5 17.7077L37.1527 23.0458L39.9591 14.4085L32.6118 9.07039H41.6936L44.5 0.433105Z"
            fill="url(#paint1_linear_61_801)"
        />
        <path
            d="M76.5 0.433105L79.3064 9.07039H88.3882L81.0409 14.4085L83.8473 23.0458L76.5 17.7077L69.1527 23.0458L71.9591 14.4085L64.6118 9.07039H73.6936L76.5 0.433105Z"
            fill="url(#paint2_linear_61_801)"
        />
        <path
            d="M108.5 0.433105L111.306 9.07039H120.388L113.041 14.4085L115.847 23.0458L108.5 17.7077L101.153 23.0458L103.959 14.4085L96.6118 9.07039H105.694L108.5 0.433105Z"
            fill="url(#paint3_linear_61_801)"
        />
        <path
            d="M140.5 0.433105L143.306 9.07039H152.388L145.041 14.4085L147.847 23.0458L140.5 17.7077L133.153 23.0458L135.959 14.4085L128.612 9.07039H137.694L140.5 0.433105Z"
            fill="url(#paint4_linear_61_801)"
        />
        <defs>
            <linearGradient id="paint0_linear_61_801" x1="12.5" y1="0.433105" x2="12.5" y2="25.4331" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFC752" />
                <stop offset="1" stopColor="#FFEDA3" />
            </linearGradient>
            <linearGradient id="paint1_linear_61_801" x1="44.5" y1="0.433105" x2="44.5" y2="25.4331" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFC752" />
                <stop offset="1" stopColor="#FFEDA3" />
            </linearGradient>
            <linearGradient id="paint2_linear_61_801" x1="76.5" y1="0.433105" x2="76.5" y2="25.4331" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFC752" />
                <stop offset="1" stopColor="#FFEDA3" />
            </linearGradient>
            <linearGradient id="paint3_linear_61_801" x1="108.5" y1="0.433105" x2="108.5" y2="25.4331" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFC752" />
                <stop offset="1" stopColor="#FFEDA3" />
            </linearGradient>
            <linearGradient id="paint4_linear_61_801" x1="140.5" y1="0.433105" x2="140.5" y2="25.4331" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFC752" />
                <stop offset="1" stopColor="#FFEDA3" />
            </linearGradient>
        </defs>
    </svg>
);

export default function H() {
    const { useLang } = useGlobal();
    const { t } = useLang('amazonsale');
    const userList = [
        {
            key: 'user1',
            name: t('sectionH_user_1_name'),
            text: t('sectionH_user_1_text'),
        },
        {
            key: 'user2',
            name: t('sectionH_user_2_name'),
            text: t('sectionH_user_2_text'),
        },
        {
            key: 'user3',
            name: t('sectionH_user_3_name'),
            text: t('sectionH_user_3_text'),
        },
        {
            key: 'user4',
            name: t('sectionH_user_4_name'),
            text: t('sectionH_user_4_text'),
        },
        {
            key: 'user5',
            name: t('sectionH_user_5_name'),
            text: t('sectionH_user_5_text'),
        },
        {
            key: 'user6',
            name: t('sectionH_user_6_name'),
            text: t('sectionH_user_6_text'),
        },
        {
            key: 'user7',
            name: t('sectionH_user_7_name'),
            text: t('sectionH_user_7_text'),
        },
        {
            key: 'user8',
            name: t('sectionH_user_8_name'),
            text: t('sectionH_user_8_text'),
        },
        {
            key: 'user9',
            name: t('sectionH_user_9_name'),
            text: t('sectionH_user_9_text'),
        },
        {
            key: 'user10',
            name: t('sectionH_user_10_name'),
            text: t('sectionH_user_10_text'),
        },
    ];

    return (
        <div id="amazon-sale-H" className={`amazon-sale-H ${css['amazon-sale-H']}`}>
            <div className="section-content">
                <p className="title">
                    <ICON_HORN />
                    {t('sectionH_title')}
                </p>
                <Swiper
                    className="user-content"
                    modules={[Scrollbar, Navigation]}
                    navigation={true}
                    spaceBetween={15}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        draggable: true,
                    }}
                >
                    {userList.map((item: any) => (
                        <SwiperSlide className={`user ${item.key}`} key={item.key}>
                            <ICON_STAR />
                            <p className="user-text">{item.text}</p>
                            <p className="user-name">-{item.name}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
